import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, ViewEncapsulation, ElementRef } from '@angular/core';
import { BaseAPIService } from '@app/Services/api.base.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { MapService } from '@app/map/map.service';
import { ICoolersDetails } from '../Models/ICoolersDetails';
import imagesLookup from '../../assets/eliwell_product_images/imagesLookupTable.json';
import { TabView } from 'primeng/tabview';
import { ActivatedRoute } from '@angular/router';
import { CalendarService } from '../Services/calendar.service';
import { Table } from 'primeng/table';
import { IGridCols } from '../Models/IGridCols';
import { TelemetryService } from '../Services/telemetry.service';
import { label } from '../constants/labels';
import { rolesdef } from '@app/constants/role-def';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';



@Component({
  selector: 'app-dashboard',
  standalone: false,
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
  // providers: [MessageService],
})
export class DashboardComponent implements OnInit, OnDestroy {
  
  @ViewChild(('filtr')) filtr: ElementRef;
  @ViewChild('editDeviceInput', { read: ElementRef }) editDeviceInput!: ElementRef;

  recordStatus?: any;
  activeCoolersCount: number;
  inactiveCoolersCount: number;
  tabDeviceStatus: number = 1;
  coolersData: ICoolersDetails[];
  cols: Array<IGridCols>;
  labels: any = label;
  noData: boolean = false;
  isPagination: boolean = true;
  showfilter: boolean = false;
  filterCriteria: string = null;
  isLoading: boolean = false;
  public editingItemId: string | null = null;
  public pendingDeviceName: string;
  deviceFullName: string;
  public rect1logo: string = null;
  public rect2logo: string = null;
  public rect3logo: string = null;
  public rect1key: string = null;
  public rect1val: number = 0;
  public rect2key: string = null;
  public rect2val: number = 0;
  public rect3key: string = null;
  public rect3val: Date = null;
  public selectedCoolerName: string;
  public status: boolean;
  public rindex: number;
  selectedTabIndex: number = 0;
  setPointValues: { min: number, max: number, val: number } = { min: -10, max: 30, val: 10 }
  targetSearch: string;
  @ViewChild('tabView') tabView!: TabView;
  @ViewChild('dt') dt!: Table;
  clonedData: ICoolersDetails[];
  LastConnDateFilter: any;
  groupedByDeviceGroups: any;

  searchText: string = '';
  allDeviceGroups: any[] = []; // Store original data
  selectedView: 'map' | 'table' | 'dock' = 'map';
  isDeviceInfoVisible: any;
  deviceFilterArray: string[] = []; // Unique device types for filter chips
  selectedDeviceTypes: string[] = []; // Currently selected device type filters (supports multiple)
  noDeviceFound: boolean = false;
  role: string;
  roles = rolesdef;
  isInstalledAssigned: boolean = false;
  private searchSubject = new Subject<string>();
  private searchSubscription: Subscription;
  editingDongleId: string;
  isEditLoader: boolean = false;

  constructor(private readonly baseService: BaseAPIService,
    private readonly auth: AuthenticationService, private readonly route: ActivatedRoute, private readonly cdr: ChangeDetectorRef,
    private readonly mapService: MapService, public calendarService: CalendarService, private readonly telemetryService: TelemetryService) { 
      this.role = this.auth.authenticatedRoleCd;
      console.log('User role in DashboardComponent:', this.role);
      this.editingItemId = null;
      this.pendingDeviceName = "";
    }

  ngOnInit() {

    this.GetDeviceData();

    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(search => {
      this.executeSearch(search);
    });
  }

  ngOnDestroy() {
    this.mapService.destroyMap();
    this.searchSubscription?.unsubscribe();
  }

  setView(view: 'map' | 'table' | 'dock') {
    // If leaving map view, destroy the map
    if (this.selectedView === 'map' && (view === 'table' || view === 'dock')) {
      this.mapService.destroyMap();
    }
    this.selectedView = view;
    // If switching to map view, re-initialize the map and add markers
    if (view === 'map') {
      setTimeout(() => {
        this.mapService.initMap('map'); // 'map' should match your map container id
        if (this.coolersData && this.coolersData.length > 0) {
          this.mapService.addCoolersMarker(this.coolersData);
        }
      }, 0);
    }
  }

  public GetDeviceData() {
    this.isLoading = true;
    const apiUrl = '/DeviceDashboard/DeviceDetailForDashboard';
    this.baseService.GetWithHeaders(apiUrl, {}).subscribe((result: ICoolersDetails[]) => {
      if (result && result.length > 0) {
        this.coolersData = result;
        this.coolersData.forEach((value) => {
          value.latitude = value.currentLatitude === null ? value.registrationLatitude : value.currentLatitude;
          value.longitude = value.currentLongitude === null ? value.registrationLongitude : value.currentLongitude;
          // Set image property based on mask+poli lookup
          const maskpoli = (value.mask || "") + (value.poli || "");
          const found = (imagesLookup as any[]).find(x => x.maskpoli === maskpoli);
          value.coolerImage = found ? 'assets/eliwell_product_images/' + found.image : null;
        });
        if (this.selectedView === 'map') {
          this.mapService.destroyMap();
          setTimeout(() => {
            this.mapService.initMap('map');
            try {
              this.mapService.addCoolersMarker(this.coolersData);
            } catch (exception) {
              console.error('Error adding markers to map:', exception);
            }
          }, 0);
        } else {
          try {
            this.mapService.addCoolersMarker(this.coolersData);
          } catch (exception) {
            console.error('Error adding markers to map:', exception);
          }
        }
        this.groupedByDeviceGroups = this.groupBy(this.coolersData, 'groups');
        this.allDeviceGroups = [...this.groupedByDeviceGroups];
        // Extract unique device types for filter chips
        this.deviceFilterArray = [...new Set(this.coolersData.map((item: any) => item.deviceType).filter(type => type))];
        
      }
      else {
        this.noDeviceFound = true;
        this.noData = true;
        this.isPagination = false;
      }
      this.isLoading = false;
    },
      error => {
        console.log(error);
      });
    
  }

  public GetCoolerLocation(latitude: number, longitude: number, name: string, coolerDet: any) {
    if(coolerDet.deviceType === 'AIREdge'){
      this.mapService.locate(latitude, longitude, coolerDet);
      this.selectedCoolerName = name;
    }    
  }
  // public closeMapMarker() {
  //   this.mapService.closePopup();
  // }
  public groupBy<T>(array: T[], key: keyof T) {

    let jsonObj = array.reduce((acc: { [key: string]: T[] }, currentItem: T) => {
      const groupKey = String(currentItem[key]); // Ensure key is a string for object property access
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(currentItem);
      return acc;
    }, {});
    return Object.entries(jsonObj).map(([key, value]) => ({
      groupName: key.trim() == '' ? 'Devices without Group' : key,
      items: value
    }));

  }

  searchAll(value) {
    this.searchSubject.next(value);
  }

  private executeSearch(value: string) {
    let search = value;
    search = search.trim().toLowerCase();
    console.log(search);
    if (search === '') {
      this.groupedByDeviceGroups = [...this.allDeviceGroups];
      this.noDeviceFound = false;
      this.updateMapMarkers();
      return;
    }
    this.groupedByDeviceGroups = this.allDeviceGroups
      .map(group => ({
        ...group,
        items: group.items.filter(item =>
          (item.name?.toLowerCase().includes(search)) ||
          (item.deviceType?.toLowerCase().includes(search)) ||
          (item.dongleUId?.toLowerCase().includes(search)) ||
          (item.controllerTypeName?.toLowerCase().includes(search)) ||
          (this.getDeviceStatusLabel(item.deviceStatus).includes(search))
        )
      }))
      .filter(group => group.items.length > 0);

    this.noDeviceFound = this.groupedByDeviceGroups.length === 0;
    this.updateMapMarkers();
  }

  private getDeviceStatusLabel(status: number): string {
    switch (status) {
      case 0: return 'offline';
      case 1: return 'online';
      default: return 'inactive';
    }
  }

  edit(deviceData, id, deviceName){
    
    this.pendingDeviceName = deviceName;
    this.deviceFullName = deviceName;
    this.editingItemId = id;
    this.editingDongleId = deviceData.dongleUId;
    setTimeout(() => {
      // Try to focus the native input inside qds-input
      const inputEl = this.editDeviceInput?.nativeElement?.querySelector('input');
      if (inputEl) {
        inputEl.focus();
      }
    });
  }

  updateDeviceName(pendingDeviceName) {
    this.isEditLoader = true;
    if (this.pendingDeviceName !== this.deviceFullName) {
      this.baseService.PATCH(`/Device/UpdateDeviceName?dongleUId=${this.editingDongleId}&${this.encodeQuery({ newDeviceName: this.pendingDeviceName })}`, {}).subscribe(() => {
          this.deviceFullName = this.pendingDeviceName;
          this.telemetryService.cooler_name = this.pendingDeviceName;
          
          // Update the item name in coolersData
          const cooler = this.coolersData.find(c => (c as any).dongleUId === this.editingDongleId);
          if (cooler) {
            cooler.name = this.pendingDeviceName;
          }
          console.log('sds', this.coolersData);
          
          // Re-group to update groupedByDeviceGroups
          this.groupedByDeviceGroups = this.groupBy(this.coolersData, 'groups');
          this.allDeviceGroups = [...this.groupedByDeviceGroups];
          this.cdr.detectChanges();
        
        // this.isLoading = false;
        this.isEditLoader = false;
        this.editingItemId = null;
      });
    } else {
      // this.isLoading = false;
      this.isEditLoader = false;
      this.editingItemId = null;
    }
  }

  cancelEdit() {
    this.editingItemId = null;
    this.pendingDeviceName = "";
  }

  encodeQuery(data) {
    let query = '';
    for (const d in data) {
      if (data[d] !== '') {
        query += `${encodeURIComponent(d)}=${data[d] instanceof Date ? new Date(data[d]).toISOString() : encodeURIComponent(data[d])}&`;
      }
    }
    return query.slice(0, -1)
  }

  showDeviceInfo(item: any) {
    if (item === null || this.isDeviceInfoVisible === item) {
      this.isDeviceInfoVisible = null;
    } else {
      this.isDeviceInfoVisible = item;
    }
  }

  onShareDevice(item: any) {
    // TODO: Implement share device functionality
    console.log('Share device:', item);
  }

  filterByDeviceType(deviceType: string) {
    console.log(deviceType);
    
    // Toggle selection - add or remove from selected array
    const index = this.selectedDeviceTypes.indexOf(deviceType);
    if (index > -1) {
      // Remove from selection
      this.selectedDeviceTypes.splice(index, 1);
    } else {
      // Add to selection
      this.selectedDeviceTypes.push(deviceType);
    }
    
    // If no filters selected, show all data
    if (this.selectedDeviceTypes.length === 0) {
      this.groupedByDeviceGroups = [...this.allDeviceGroups];
      this.updateMapMarkers();
      return;
    }
    
    // Filter the data based on selected device types
    this.groupedByDeviceGroups = this.allDeviceGroups
      .map(group => ({
        ...group,
        items: group.items.filter((item: any) => this.selectedDeviceTypes.includes(item.deviceType))
      }))
      .filter(group => group.items.length > 0);
    
    this.updateMapMarkers();
  }

  /**
   * Collects all visible devices from the filtered groups and updates the map markers.
   */
  private updateMapMarkers() {
    const filteredDevices = this.groupedByDeviceGroups.reduce((acc: ICoolersDetails[], group: any) => {
      return acc.concat(group.items);
    }, []);
    try {
      this.mapService.addCoolersMarker(filteredDevices);
    } catch (exception) {
      console.error('Error updating map markers:', exception);
    }
  }

  public navigateToRemoteLink(remoteLink: string) {
    window.open(remoteLink, '_blank');
  }

  
}
